<div fxLayoutAlign="start stretch" fxFlex="100%">
	<mat-card class="mat-elevation-z2 no-padding">
		<div fxLayout="column" ngClass="p-b-s">
			<img src="{{ this.featuredCardData.image }}" fxFill />
		</div>
		<mat-card-header>
			<mat-card-title class="inc-span-height">
				{{
					this.featuredCardData?.title?.length > 22
						? this.featuredCardData.title.slice(0, 22) + '...'
						: this.featuredCardData.title
				}}
			</mat-card-title>
			<mat-card-subtitle>
				<mat-chip-listbox
					aria-label="category selection"
					id="chip-list"
					name="chip-list"
					class="whydonate-light"
				>
					<mat-chip class="mat-chip-list-stacked my-chip">
						<span class="mat-subtitle-2">
							{{ this.featuredCardData.category }}
						</span>
					</mat-chip>
				</mat-chip-listbox>
			</mat-card-subtitle>
		</mat-card-header>
		<mat-card-content
			fxLayout="column"
			fxLayoutAlign="flex-start flex-start"
			fxLayoutGap="3%"
		>
			<div>
				<div>
					<p>
						{{
							this.featuredCardData?.description?.length > 145
								? this.featuredCardData.description.slice(0, 145) + ' ...'
								: this.featuredCardData.description
						}}
					</p>
				</div>
			</div>
			<div ngClass="p-t-m"></div>
			<div class="bottom-sticky">
				<div *ngIf="featuredCardData?.link?.includes('/donate/')">
					<button
						mat-stroked-button
						color="accent"
						(click)="redirectToDonate(featuredCardData?.link)"
					>
						<span
							class="mat-headline-6"
							i18n="@@homepage_personal_featuredTopics_donateNow"
							>Donate Now</span
						>
					</button>
				</div>
				<div *ngIf="!featuredCardData?.link?.includes('/donate/')">
					<button
						mat-stroked-button
						color="accent"
						(click)="redirectToDonate(featuredCardData?.link)"
					>
						<span class="mat-headline-6" i18n="@@button_learnMore">Learn More</span>
					</button>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>
